import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";

const ToothFairySearch = ({ children }) => {
  const { currentTheme } = AppTheme.useTheme();

  return (
    <View
      style={{
        backgroundColor: currentTheme?.theme?.softBackgroundColor,
        padding: 10,
      }}
    >
      <View>{children}</View>
    </View>
  );
};

export default ToothFairySearch;
